import { render } from "./uiAsideMenu.vue?vue&type=template&id=376ad289"
import script from "./uiAsideMenu.vue?vue&type=script&lang=js"
export * from "./uiAsideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__